import type { MeResponse } from '@lp/shared';

export type ConsoleSectionPath =
  | '/admin/courses'
  | '/admin/guides'
  | '/admin/users'
  | '/admin/analytics'
  | '/admin/audit'
  | '/admin/observability';

type Capabilities = MeResponse['capabilities'];

/**
 * Which console sections a person can see, in nav order. Sections they cannot
 * use are left out entirely — the nav and the route guards both read this, so
 * a hidden section is also unreachable by URL. The server still checks every
 * call on its own.
 */
export function consoleSections(c: Capabilities): { to: ConsoleSectionPath }[] {
  const authorsCourses = c.isAdmin || c.isInstructor || c.isCourseAdmin;
  const visible: Record<ConsoleSectionPath, boolean> = {
    '/admin/courses': authorsCourses,
    '/admin/guides': c.isAdmin || c.isGuideWriter,
    '/admin/users': c.isAdmin,
    '/admin/analytics': authorsCourses,
    '/admin/audit': c.isAdmin,
    '/admin/observability': c.isAdmin,
  };
  return (Object.keys(visible) as ConsoleSectionPath[])
    .filter((to) => visible[to])
    .map((to) => ({ to }));
}

export function canSeeConsoleSection(c: Capabilities, to: ConsoleSectionPath): boolean {
  return consoleSections(c).some((s) => s.to === to);
}
